// extracted by mini-css-extract-plugin
module.exports = {"text":"PageText_text___Bb5L","load":"PageText_load__DEMzO"};